import React, {useContext} from 'react';
import { StocksContext } from '../App'
import CompanyOverview from "./CompanyOverview";
import CompanyDetails from "./CompanyDetails";
import CompanyPeers from "./CompanyPeers";

function Details() {
    const sharedStates = useContext(StocksContext)

    let sectorSymblDetails = sharedStates.stocksArr.find((currentSymbObj) => {
        return currentSymbObj.symbol === sharedStates.selectedSymbl;
    });

    return (
        <div className="details-container">
            <CompanyOverview sharedStates={sharedStates} currentSymbolDetails={sectorSymblDetails}/>
            <CompanyDetails sharedStates={sharedStates} />
            <CompanyPeers sharedStates={sharedStates}  />
        </div>
    );
}

export default Details;
